module.exports = __webpack_public_path__ + "static/media/9DESA15.bc4ba0ff.jpg";